import React, { Component } from 'react';
import { Card, Header, Button, Image, Icon, Form, Feed, Divider, Menu, Grid } from 'semantic-ui-react'
import { Link } from 'react-router-dom';
import AddCouponToOrder from '../newDashboard/AddCouponToOrder/AddCouponToOrder'
import Status from '../../../config/OrderStatusConstants.js'
import ImageUploader from '../../newSite/ImageUploader'
import * as moment from 'moment';
import { getOrderKey, toCurrency } from '../../../config/constants';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import OrderCard from './OrderCard'
import SetVinylHeatPress from './Vinyl/SetHeatPressOrVinyl';
import createBrowserHistory from 'history/createBrowserHistory';
import ShirtFoundSingleOrderForArrays from './ShirtFound/ShirtFoundSingleOrderForArrays';
import JerseyQuality from './FootBallQuality/JerseyQuality';
import SendNotifToClientOnNewDesign from '../../newSite/DesignChat/SendNotifToClientOnNewDesign';
import { ShowSentSms } from '../../newSite/DesignChat/MiscUiParts';
import ReturnStock from './AddBackToStock/ReturnStock';
import CheckOrderProjectInfo from './LargeProjects/CheckOrderProjectInfo.js';


//import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

/**
 * BUTTON TO VERIFY ORDER
 * @param {*} props 
 */
export function VerifyOrderButton(props) {

    const verifyUI = props.order.verified === true
        ? (<p>VERFIED</p>)
        : (<Button>
            <Link to={'/dashboard/verifyOrder/' + props.order.key}>Verify</Link>
        </Button>)

    return (
        <div>
            {verifyUI}
        </div>
    )

}

/**
 * GET THE COLOR TO SHOW FOR THE STATUS BUTTON
 * @param {*} props 
 */
export function OrderStatus(props) {

    let statusColor = 'red';

    switch (props.status) {
        case 'new':
            statusColor = 'red';
            break;
        case Status.customer_contacted:
            statusColor = Status.customer_contacted_color;
            break;
        case Status.ready_to_design:
            statusColor = Status.ready_to_design_color;
            break;
        case Status.designing_started:
            statusColor = Status.designing_started_color;
            break;
        case Status.new_design_added:
            statusColor = Status.new_design_added_color;
            break;
        case Status.clnt_chckng_dsgn:
            statusColor = Status.clnt_chckng_dsgn_color;
            break;
        case 'verified':
            statusColor = 'orange';
            break;
        case 'materials_ok':
            statusColor = 'yellow';
            break;
        case 'designing':
            statusColor = 'teal';
            break;
        case 'screen_printing':
            statusColor = 'blue';
            break;
        case 'printing':
            statusColor = 'violet';
            break;
        case 'packing':
            statusColor = 'purple';
            break;
        case 'out_delivery':
            statusColor = 'pink';
            break;
        case 'delivered':
            statusColor = 'green';
            break;
        default:
            statusColor = 'red';
    }

    return (
        <Button color={statusColor}>{props.status}</Button>
    )
}


/**
 * UPLOAD DESIGN BUTTON
 */
export function UploadDesign(props) {


    let uploadUi = (
        <Card.Content extra>
            <div className='ui two buttons'>
                <Button basic color='green'>
                    UPLOAD DESIGN
                    <ImageUploader
                        updateWhenFileUploadComplete={props.designUploadComplete}
                        storageReference={'finalOrderDesigns'}
                        fileName={props.order.order_num + '_design'} />
                </Button>
            </div>
        </Card.Content>
    )


    // ORIGINAL = fileName={props.order.order_num + '_design'} 
    let millisecs = new Date().getTime();

    /**
     * IF ITS IS IN DESIGN STATUS
     */
    if (props.order.status === Status.designing
        || props.order.status === Status.screen_printing
        || props.order.status === Status.clnt_apprvd_dsgn
        || props.order.status === Status.clnt_chckng_dsgn
        || props.order.status === Status.clnt_rejectd_dsgn
        || props.order.status === Status.designing_started
        || props.order.status === Status.start_dsng_kimoto
        || props.order.status === Status.start_dsng_scrn
        || props.order.status === Status.fin_dsng_scrn
        || props.order.status === Status.fin_dsng_kimoto) {
        uploadUi = (
            <Card.Content extra>
                <div className='ui two buttons'>
                    <Button basic color='green'>
                        UPLOAD DESIGN
                        <ImageUploader
                            updateWhenFileUploadComplete={props.designUploadComplete}
                            storageReference={'finalOrderDesigns'}
                            fileName={props.order.order_num + '_design_' + millisecs} />
                    </Button>
                </div>

            </Card.Content>
        )
    } else {
        uploadUi = <br />
    }

    // const sendButton = (props.user.email == 'ivanmworozi@gmail.com'
    //     || props.user.email == 'musiimesimon4@gmail.com'
    //     || props.user.email == 'nathankinene@gmail.com'
    //     || props.user.email == 'alijibril2@gmail.com'
    //     || props.user.email == 'francis@printboda.com'
    //     || props.user.email == 'onek@printboda.com')
    //     && (props.order.status === Status.new_design_added)
    //     && props.order.designImageUrl
    //     ? <SendNotifToClientOnNewDesign
    //         order={props.order}
    //         user={props.user}
    //     />
    //     : ''

    const showSentSmsInfo = props.order.designSmsSent
        ? <ShowSentSms
            order={props.order}
            user={props.user} />
        : ''

    return (
        <div>
            {uploadUi}
            {/* {sendButton} */}
            {showSentSmsInfo}
        </div>
    )
}

/**
 * DETAIL SECTION OF CARD..
 * @param {*} props 
 */
export function CardOrderDetails(props) {
    return (
        <div>
            <Card.Content extra>
                {props.order.dateString}
            </Card.Content>
            
            <Card.Content extra>
                {/* PHONE<a href="tel:{props.order.phone}">{props.order.phone}</a> */}
                PHONE:<Link to={`tel:${props.order.phone}`} >{props.order.phone}</Link>
            </Card.Content>
            <Card.Content extra>
                SPECIAL INSTRUCTIONS:{props.order.special_instructions}
            </Card.Content>

        </div>
    )
}

export function ViewOrderLink(props) {
    return (
        // <p><Link to={'/viewOrder/'+props.order.key}>VIEW ORDER</Link></p>
        // <p><Button onClick={() => history.push('/viewOrder/' + props.order.key)}>VIEW</Button></p>
        // <p><Button><a href={'https://printboda.com/dashboard/singleOrderView/' + props.order.order_num} target="_blank">VIEW</a></Button></p>
        <p><Button fluid color='yellow'> <Link to={'/dashboard/singleOrderView/' + props.order.order_num} target="_blank">VIEW order</Link></Button></p>

    )
}

export function EditOrderLink(props) {
    return (
        // <p><Link to={'/viewOrder/'+props.order.key}>VIEW ORDER</Link></p>
        // <p><Button onClick={() => history.push('/dashboard/editOrder/' + props.order.key)}>EDIT</Button></p>

        // <p><Button><a href={'https://printboda.com/dashboard/' + props.order.key} target="_blank">EDIT</a></Button></p>
        <p><Button><a href={'http://localhost:3000/dashboard/editOrder/' + props.order.key} target="_blank">EDIT</a></Button></p>
    )
}


export function UpdateComment(props) {
     //console.log("upx21 ++++++ comment cardxxx");

    // const updatesFeed = props.showUpdates
    //     ? <Form>
    //         <Card.Content extra>
    //             <Form.Input onChange={props.handleTextChange} name="updateText" value={props.textValue} placeholder='Update Order' />
    //             <Form.Button onClick={props.updateCommentFormSubmit}> UPDATE order</Form.Button>
    //         </Card.Content>
    //     </Form>
    //     : <p></p>

    return (

        <div>
            {/* {updatesFeed} */}
            <Divider horizontal>{'ADD ORDER UPDATE'}</Divider>
            <Form>
                <Card.Content extra>
                    <Form.Input onChange={props.handleTextChange} name="updateText" value={props.textValue} placeholder='Update Order' />
                    <Form.Button fluid color='brown' onClick={props.updateCommentFormSubmit}> UPDATE order</Form.Button>
                </Card.Content>
            </Form>
        </div>
    )
}

export function ShowEmail(props) {

    const udpatedBy = props.updatedBy
        ? <Feed.Summary>
            BY: {props.updatedBy}
        </Feed.Summary>
        : ''

    return (
        <div>
            {udpatedBy}
        </div>
    )
}

export function AlogoliaOrderUpdateFeed_BADDONTUSE(props) {

    let showUpdates = false;

    if (props.order.algoliaOrderUpdates) {
        console.log("upx778 props.order.algoliaOrderUpdates exists)");
        showUpdates = true;
        console.log("upx77811 algoliaOrderUpdates size:" + props.order.algoliaOrderUpdates.length + " " + getOrderKey(props.order) + " " + props.order.order_num);

    } else {
        console.log("upx7781 props.order.algoliaOrderUpdates DOES NOT exists)");

    }

    let updates = '';

    //if (props.orderUpdates && Array.isArray(props.orderUpdates)) {
    if (props.order.algoliaOrderUpdates) {

        console.log("upx778 props.orderUpdates " + " " + props.order.order_num);
        console.log("upx7783 props.orderUpdates :" + " " + JSON.stringify(props.order.algoliaOrderUpdates, null, 3));

        updates = props.order.algoliaOrderUpdates.map((update) =>

            <Feed.Event>
                <Feed.Content>
                    <Feed.Summary>
                        {update.updateText}
                    </Feed.Summary>
                    <Feed.Meta>
                        <Feed.Like>
                            {update.time}
                        </Feed.Like>
                        <ShowEmail updatedBy={update.updatedBy} />
                    </Feed.Meta>
                </Feed.Content>
            </Feed.Event>
        );
    } else {
       // console.log("upx7784 no updates");
        updates = <h4> CLICK VIEW TO SEE UPDATES </h4>
    }

    return (
        <div>

            <Feed>
                {updates}
            </Feed>
            {/* <Button color='green' onClick={props.syncOrderUpdates}>VIEW UPDATES</Button> */}
        </div>

    )
}

export function OrderUpdateFeed(props) {



    // console.log("upx7751 udpate size:" + props.orderUpdates.length + " " + getOrderKey(props.order) + " " + props.order.order_num);
    // console.log("upx77510 searchNow:" + props.searchNow);
    // props.syncOrderUpdates();

    let updates = '';

    //if (props.orderUpdates && Array.isArray(props.orderUpdates)) {
    if (!props.searchNow) {

       // console.log("upx77512 props.orderUpdates && Array.isArray(props.orderUpdates:" + " " + props.order.order_num);
        //console.log("upx77513 props.orderUpdates :" + " " + JSON.stringify(props.orderUpdates, null, 3));

        updates = props.orderUpdates.map((update) =>

            <Feed.Event>
                <Feed.Content>
                    <Feed.Summary>
                        {update.updateText}
                    </Feed.Summary>
                    <Feed.Meta>
                        <Feed.Like>
                            {update.time}
                        </Feed.Like>
                        <ShowEmail updatedBy={update.updatedBy} />
                    </Feed.Meta>
                </Feed.Content>
            </Feed.Event>
        );
    } else {
       // console.log("upx77514 props.orderUpdates NOT AN ARRAY" + " " + props.order.order_num);
    }


    // const updates =  props.orderUpdates.map((update) =>

    //     <Feed.Event>
    //         <Feed.Content>
    //             <Feed.Summary>
    //                 {update.updateText}
    //             </Feed.Summary>
    //             <Feed.Meta>
    //                 <Feed.Like>
    //                     {update.time}
    //                 </Feed.Like>
    //                 <ShowEmail updatedBy={update.updatedBy} />
    //             </Feed.Meta>
    //         </Feed.Content>
    //     </Feed.Event>
    // );



    return (
        <div>

            <Feed>
                {updates}
            </Feed>
            <Button color='green' onClick={props.syncOrderUpdates}>VIEW UPDATES</Button>
        </div>

    )
}

export function CustomerRejectDesigns(props) {

    const rejectButton = props.order.status === Status.clnt_chckng_dsgn
        ? (
            <div>
                <Divider horizontal>{'CUSTOMER REPLY'}</Divider>
                <Button onClick={props.clientRejectDesignFunction} color='red'> Client Rejected </Button>
            </div>
        )
        : ("")

    return (
        <div>{rejectButton}</div>
    )
}

/**
 * SHOW THE DIFFERENT ORDER PARTS
 */
export function ShowOrderDetailsSection(props) {

    const oldOrderDetails = props.order.order1
        ? <p>NEW ORDER</p>
        : <CardOrderDetails order={props.order} />


    //SPEICAL INSTRUCSTIONS
    const specialInstructions = (
        <Card.Content extra>
            <Header sub> SPECIAL INSTR:</Header>
            {props.order.special_instructions}
        </Card.Content>
    )

    const pricing_notes = (
        <Card.Content extra>
            <Header sub> SPECIAL pricing:</Header>
            {props.order.pricing_notes}
        </Card.Content>
    )


    //ADDRESS
    const address = (
        <Card.Content extra>
            <Header sub>ADDRESS:</Header>
            {props.order.address}
        </Card.Content>
    )

    const creditScoreUi = props.order.creditScore != null ? (
        <div>
            <br />
            <Card.Content extra>
                <Header color='purple' sub>CREDIT SCORE:</Header>
                {props.order.creditScore}
            </Card.Content>
            <br />
        </div>
    )
        : '';

    const couponValid = props.order.couponValid != null ? (
        <div>
            <br />
            <Card.Content extra>
                <Header color='orange' sub>COUPON VALID:</Header>
                {props.order.couponValid} :: {props.order.coupon}
            </Card.Content>
            <br />
        </div>
    )
        : (
            <div>
                <br />
                <Card.Content extra>
                    <Header color='red' sub>NO COUPON:</Header>
                </Card.Content>
                {/* ADD COUPON TO ORDER */}
                <AddCouponToOrder order={props.order} user={props.user} />
                <br />
            </div>
        );

    const receiptInfo = props.order.recieptNum
        ? (
            <div>
                <br />
                <Divider horizontal>{'RECEIPT INFO'}</Divider>
                <Card.Content extra>
                    <Header color='orange' sub>RECEIPT NUM:</Header>
                    {props.order.recieptNum} - {props.order.reciptNumUpdated}
                </Card.Content>
                <Card.Content extra>{props.order.recieptCheckString}</Card.Content>
                <Card.Content extra><Link to={'/dashboard/viewReceipt/'+props.order.recieptNum}>VIEW</Link></Card.Content>
                <br />
            </div>
        )
        : ''


    //WHOLE VIEW ORDER UI
    const viewOrderUI = true
        ? <div>
            {oldOrderDetails}
            {/* {shirtText}
            {shirtBackText} */}
            {/* {order1}
            {order2}
            {order3} */}
            <br />
            {address}
            {specialInstructions}
            {pricing_notes}
            {/* {bringJerseyCardUi} */}
            {creditScoreUi}
            {/* {couponValid} */}
            {receiptInfo}

        </div>
        : <p>-</p>


    const showAlways = (
        <div>
            <br />
            <Card.Content extra>
                {/* PHONE<a href="tel:{props.order.phone}">{props.order.phone}</a> */}
                PHONE:<Link to={`tel:${props.order.phone}`} >{props.order.phone}</Link>
            </Card.Content>
        </div>
    )

    return (
        <div>
            {/* <Button type='button' onClick={props.viewOrderDetailsToggle} content='DETAILS' color='blue' /> */}
            <br />
            {showAlways}
            {viewOrderUI}
        </div>
    )
}

/**
 * SHOW THE DETIALS OF EACH ORDER TYPE..
 * @param {*} props 
 */
export function ShowSingleOrderDetails(props) {

    // console.log("ShowSingleOrderDetails:"+props.mainOrder.itemType);
    //console.log("vlx2 ShowSingleOrderDetails - user email:"+props.user.email);
    // console.log("vlx3 mainOrder:"+JSON.stringify(props.mainOrder, null, 3));
    const shirtFrontText = props.order.shirtText
        ? <div><span>SHIRT FRONT TEXT:{props.order.shirtText}</span><br /></div>
        : ''

    const shirtBackText = props.order.shirtBackText
        ? <div><span>SHIRT BACK TEXT:{props.order.shirtBackText}</span><br /></div>
        : ''

    const userUploadedImage = props.order.imageUrl
        ? (<Image src={props.order.imageUrl} size='medium' centered bordered shape='rounded' />)
        : (<p></p>)

    const childsAge = props.order.childsAge
        ? <div><span>CHILDS AGE:{props.order.childsAge}</span></div>
        : ''

    const jerseyNumber = props.order.jerseyNumber
        ? <span>JERSEY NUMBER -:{props.order.jerseyNumber}</span>
        : ''

    const jerseyQuality = props.order.jerseyQuality
        ? <span>JERSEY QUALITY-:{props.order.jerseyQuality}</span>
        : ''

    const jerseyName = props.order.jerseyName
        ? <div>
            <span>JERSEY NAME:{props.order.jerseyName}</span>
            <br />
        </div>
        : ''

    const footballDetails = props.order.teamSelection || props.order.typedInTeamName
        ? <div>
            <span>TEAM:{props.order.teamSelection}</span>
            <br />
            <span>TEAM (TYPED IN):{props.order.typedInTeamName}</span>
            <br />
        </div>
        : ''

    const sleeves = props.order.sleeves
        ? <div>
            <span>SLEEVES:{props.order.sleeves}</span>
            <br />
        </div>
        : ''

    const templateText = props.order.templateText
        ? <div>
            <span>TEMPLATE TEXT:{props.order.templateText}</span>
            <br />
        </div>
        : ''

    const usePuff = props.order.usePuff
        ? <div>
            <span>USE PUFF:{props.order.usePuff}</span>
            <br />
        </div>
        : ''


    const changeJerseyQuality = props.mainOrder.itemType === 'football'
        ? <JerseyQuality
            user={props.user}
            mainOrder={props.mainOrder}
            orderId={props.order.key}
            order={props.order} />
        : ''

    //  const shirtFound = props.order.shirtFound
    const shirtFoundBuyShirtButtons = props.mainOrder.status !== 'lost'
        && props.mainOrder.status !== 'packing'
        && props.mainOrder.status !== 'printing'
        && props.mainOrder.status !== 'stuck'
        && props.mainOrder.status !== 'cancelled'
        && props.mainOrder.status !== 'confirm_order'
        && props.mainOrder.status !== 'delivered'
        && props.mainOrder.status !== 'totalLoss'
        && !props.searchNow
        // ? <h4 color='red'>SHIRT IS AVAIL</h4>
        ? <ShirtFoundSingleOrderForArrays
            mainOrder={props.mainOrder}
            orderNumber={props.orderNumber}
            singleOrder={props.order} />
        : ""


    const siniyaDonation = props.order.siniyaDonation
        ? <div>
            <span>SINIYA DONATION:{props.order.siniyaDonation}</span>
            <br />
        </div>
        : ''

    //HEAT PRESS OR VINYL
    const heatPressOrVinyl = props.mainOrder.itemType !== 'cranes' && props.mainOrder.itemType !== 'football'
        ? <SetVinylHeatPress
            user={props.user}
            orderId={props.order.key}
            order={props.order}
            mainOrder={props.mainOrder} />
        : ''

    const photoType = props.order.photoType
        ? <div>
            <span>PHOTO TYPE:{props.order.photoType}</span>
            <br />
        </div>
        : ''

    const kitengeType = props.order.kitengeType
        ? <div>
            <span>kitenge:{props.order.kitengeType}</span>
            <br />
        </div>
        : ''

    const kitengeShirt = props.order.kitengeShirt
        ? <div>
            <span>kitengeShirt:{props.order.kitengeShirt}</span>
            <br />
        </div>
        : ''

    const phoneManufa = props.order.phoneManufa
        ? <div>
            <span>Phone Manufa:{props.order.phoneManufa}</span>
            <br />
        </div>
        : ''

    const phoneModel = props.order.phoneModel
        ? <div>
            <span>Phone Model:{props.order.phoneModel}</span>
            <br />
        </div>
        : ''

    const giftBoxColor = props.order.giftBoxColor
        ? <div>
            <span>giftBoxColor:{props.order.giftBoxColor}</span>
            <br />
        </div>
        : ''

    const returnToStockButton = (props.mainOrder.status === Status.stuck
        || props.mainOrder.status === Status.lost)
        && props.mainOrder.itemType === 'phoneCase_wooden'
        // && props.mainOrder.status !== Status.
        // && props.mainOrder.status !== 'stuck'
        // && props.mainOrder.status !== 'cancelled'
        // && props.mainOrder.status !== 'confirm_order'
        // && props.mainOrder.status !== 'delivered'
        // && props.mainOrder.status !== 'totalLoss'
        // ? <h4 color='red'>SHIRT IS AVAIL</h4>
        ? <ReturnStock
            user={props.user}
            mainOrder={props.mainOrder}
            orderNumber={props.orderNumber}
            order={props.order} />
        : ""

    return (
        <div>
            {usePuff}
            {shirtFrontText}
            {shirtBackText}
            <span>Shirt Color:{props.order.shirtColor}</span>
            <br />
            <span>Shirt Size:{props.order.shirtSize}</span>
            <br />
            {childsAge}
            <span>Shirt Type:{props.order.shirtType}</span>
            <br />
            <span>Shirt Qty:{props.order.qty}</span>
            <br />
            {photoType}
            {/* {giftBoxColor} */}
            {kitengeType}
            {kitengeShirt}
            <br />
            {jerseyName}
            {jerseyNumber}
            <br />
            {jerseyQuality}
            {footballDetails}
            {sleeves}
            {changeJerseyQuality}

            {templateText}

            {phoneManufa}
            {phoneModel}
            {userUploadedImage}

            {/* {siniyaDonation} */}
            {shirtFoundBuyShirtButtons}
            {/* {heatPressOrVinyl} */}


            {returnToStockButton}


        </div>
    )
}

export function GetTimeAgo(props) {

    var a = moment(props.dateNum);
    var b = moment();
    // var dayCount = a.diff(b, 'days');

    var dayCount = b.diff(a, 'days');
    // console.log("dayCount:"+dayCount);

    let color = 'green'

    if (dayCount > 3) {
        color = 'red'
    }

    return (
        <Header as='h4' color={color}>
            <Icon name='clock' />
            <Header.Content>
                {moment(props.dateNum).fromNow()}
            </Header.Content>
        </Header>
    )
}



export function MarkNumbersChecked(props) {

    const showButton = props.order.numberChecked && props.order.itemType == 'cranes'
        ? ""
        : <Button color='violet' onClick={props.markNumbersChecked}>NUM CHECKED</Button>

    return (
        <div>
            {showButton}
        </div>
    )
}

export function ShowNumChecked(props) {

    const showifMarked = props.order.numberChecked
        ? <p>NUM CHECKED</p>
        : <p> NOT CHECKED </p>

    return (
        <div>
            {showifMarked}
        </div>
    )
}

// export function EnterCranesNumber(props) {

//     const numberForm = props.order.itemType == 'cranes'
//         ? <Form>
//             <Card.Content extra>
//                 <Form.Input onChange={props.handleTextChange}
//                     name="cranesNumber" value={props.cranesNumber} placeholder='Update Order' />
//                 <Form.Button onClick={props.updateCranesNumber}> UPDATE NUM</Form.Button>
//             </Card.Content>
//         </Form>
//         : ""


//     return (
//         <div>
//             {numberForm}
//         </div>
//     )
// }

// export function ShowCranesNumber(props) {

//     const numberForm = props.order.itemType == 'cranes' && props.order.jerseyNumber
//         ? <Header as='h4' color={'blue'}>
//             <Icon name='slack' />
//             <Header.Content>
//                 C#{props.order.jerseyNumber}
//             </Header.Content>
//         </Header>
//         : ""

//     return (
//         <div>
//             {numberForm}
//         </div>
//     )
// }

export function ItemCostUI(props) {

    const wholeUI = props.order.itemCost
        ? <div>
            <Divider horizontal>{'ITEM COST'}</Divider>
            <Card.Content extra>
                {/* PHONE<a href="tel:{props.order.phone}">{props.order.phone}</a> */}
                itemCost: {toCurrency(props.order.itemCost)}
            </Card.Content>
            <Card.Content extra>
                {/* PHONE<a href="tel:{props.order.phone}">{props.order.phone}</a> */}
                itemCost_item: {props.order.itemCost_item}
            </Card.Content>
            </div>
        : ""


    return (
        <div>
            {wholeUI}
        </div>
    )
}


export function LostButton(props) {

    const lostButton = props.order.status !== Status.lost && props.order.status !== Status.delivered
        ? <div>
            <Divider horizontal>{'LOST'}</Divider>
            <Button color='purple' onClick={props.makeOrderLost}>MARK LOST</Button>
            </div>
        : ""

    const showForLost = props.order.status === Status.lost
        ? <div>
            <Divider horizontal>{'LOST'}</Divider>
            <p>LOST ORDER </p>
        </div>
        : ""

    return (
        <div>
            
            {lostButton}
            {showForLost}
        </div>
    )
}

export function TopMenu(props) {
    return (

        <Menu>
            {/* HOME */}
            <Menu.Item name='video camera' onClick={props.showNoNumbers} color='red'>
                <Icon name='home' />
                <Link to={'/dashboard'}>HOME</Link>
            </Menu.Item>
        </Menu>
    )
}

export function CopyOrderLink(props) {

    return (
        <CopyToClipboard text={'https://printboda.com/viewOrder/' + props.order.key}
            onCopy={() => this.setState({ copied: true })}>
            <Button color='brown'>COPY ORDER LINK</Button>
        </CopyToClipboard>
    )
}

/**
 * SHOW WHEN ORDER WAS LAST UPDATE
 */
export function ShowLastUpdate(props) {

    const showLastUpdate = props.order.lastUdpatedSecs
        ? <Header as='h4' color={'teal'}>
            <Icon name='clock' />
            <Header.Content>
                UDPATED: {moment(props.order.lastUdpatedSecs).fromNow()}
            </Header.Content>
        </Header>
        : ''

    return (
        <div>
            {showLastUpdate}
        </div>
    )
}

export function ShowType(props) {

    let uiToShow = '';

    switch (props.order.itemType) {
        case 'football':
            uiToShow = <Header as='h4'>
                <Icon color='red' name='recycle' />
                <Header.Content>
                    FOOTBALL
            </Header.Content>
            </Header>
            break;
        case 'cranes':
            uiToShow = <Header as='h4'>
                <Icon color='yellow' name='flag' />
                <Header.Content>
                    CRANES
            </Header.Content>
            </Header>
            break;
        case 'jumper':
            uiToShow = <Header as='h4'>
                <Icon color='olive' name='child' />
                <Header.Content>
                    JUMPER
            </Header.Content>
            </Header>
            break;
        case 'cup':
            uiToShow = <Header as='h4'>
                <Icon name='flask' />
                <Header.Content>
                    CUP
            </Header.Content>
            </Header>
            break;
        case 'template':
            uiToShow = <Header as='h4'>
                <Icon name='shopping bag' />
                <Header.Content>
                    TEMPLATE
            </Header.Content>
            </Header>
            break;
        case 'vest':
            uiToShow = <Header as='h4'>
                <Icon name='cny' />
                <Header.Content>
                    VEST
            </Header.Content>
            </Header>
            break;
        case 'pillow':
            uiToShow = <Header as='h4'>
                <Icon name='pinterest' />
                <Header.Content>
                    PILLOW
            </Header.Content>
            </Header>
            break;
        case 'cap':
            uiToShow = <Header as='h4'>
                <Icon name='snapchat ghost' />
                <Header.Content>
                    CAP
            </Header.Content>
            </Header>
            break;
        case 'robe':
            uiToShow = <Header as='h4'>
                <Icon name='user' />
                <Header.Content>
                    robe
            </Header.Content>
            </Header>
            break;
        case 'flag':
            uiToShow = <Header as='h4'>
                <Icon name='flag checkered' />
                <Header.Content>
                    flag
            </Header.Content>
            </Header>
            break;
        case 'phoneCase':
            uiToShow = <Header as='h4'>
                <Icon color='green' name='phone' />
                <Header.Content>
                    PHONECASE
            </Header.Content>
            </Header>
            break;
        case 'jacket':
            uiToShow = <Header as='h4'>
                <Icon  name='neuter' />
                <Header.Content>
                    JACKET
            </Header.Content>
            </Header>
            break;
        case 'clock':
            uiToShow = <Header as='h4'>
                <Icon name='clock' />
                <Header.Content>
                    CLOCK
            </Header.Content>
            </Header>
            break;
        case 'bracelet':
            uiToShow = <Header as='h4'>
                <Icon color='teal' name='chain' />
                <Header.Content>
                    BRACELET
            </Header.Content>
            </Header>
            break;
        case 'storageBoxes':
            uiToShow = <Header as='h4'>
                <Icon name='dropbox' />
                <Header.Content>
                    STORAGE BOX
            </Header.Content>
            </Header>
            break;
        case 'office_shirts':
            uiToShow = <Header as='h4'>
                <Icon color='blue' name='chess knight' />
                <Header.Content>
                    OFFICE SHIRTS
            </Header.Content>
            </Header>
            break;
        case 'wristband':
            uiToShow = <Header as='h4'>
                <Icon color='purple' name='life ring' />
                <Header.Content>
                    WRISTBAND
            </Header.Content>
            </Header>
            break;
        case 'phoneCase_wooden':
            uiToShow = <Header as='h4'>
                <Icon color='brown' name='won' />
                <Header.Content>
                    WOODEN CASE
            </Header.Content>
            </Header>
            break;
        case 'shirtDress':
            uiToShow = <Header as='h4'>
                <Icon name='female' />
                <Header.Content>
                    SHIRT DRESS
            </Header.Content>
            </Header>
            break;
        case 'cropTop':
            uiToShow = <Header as='h4'>
                <Icon name='i cursor' />
                <Header.Content>
                    CROP TOP
            </Header.Content>
            </Header>
            break;
        case 'pictureFrame':
            uiToShow = <Header as='h4'>
                <Icon name='checkmark box' />
                <Header.Content>
                    PICTURE FRAME
                </Header.Content>
            </Header>
            break;
        case 'keychain':
            uiToShow = <Header as='h4'>
                <Icon name='key' />
                <Header.Content>
                    KEY CHAIN
                    </Header.Content>
            </Header>
            break;
        case 'metal_bracelet':
            uiToShow = <Header as='h4'>
                <Icon name='handshake' />
                <Header.Content>
                    METAL BRACELET
                        </Header.Content>
            </Header>
            break;
        case 'metal_dogtag':
            uiToShow = <Header as='h4'>
                <Icon name='lock' />
                <Header.Content>
                    METAL dog tag
                            </Header.Content>
            </Header>
            break;
        case 'umbrella':
            uiToShow = <Header as='h4'>
                <Icon name='umbrella' />
                <Header.Content>
                    UMBRELLA
                                </Header.Content>
            </Header>
            break;
        case 'usb_wooden':
            uiToShow = <Header as='h4'>
                <Icon name='usb' />
                <Header.Content>
                    USB WOODEN
                                    </Header.Content>
            </Header>
            break;
        case 'daily_planner':
            uiToShow = <Header as='h4'>
                <Icon name='address book' />
                <Header.Content>
                    DAILY PLANNER
                                        </Header.Content>
            </Header>
            break;
        case 'vacuum_flask':
            uiToShow = <Header as='h4'>
                <Icon name='shopping bag' />
                <Header.Content>
                    vacuum_flask
                                            </Header.Content>
            </Header>
            break;
        default:
            uiToShow = <Header as='h4'>
                <Icon name='shirtsinbulk' />
                <Header.Content>
                    NORMAL
        </Header.Content>
            </Header>
    }

    return (
        <div>{uiToShow}</div>
    )
}

export function SendToFindShirt(props) {
    const sendButton = props.order.itemType === 'football'
        || props.order.itemType === 'cranes'
        || (props.order.templateId && props.order.templateId === 71)
        || (props.order.templateId && props.order.templateId === 72)
        || (props.order.templateId && props.order.templateId === 73)
        || (props.order.templateId && props.order.templateId === 74)
        || (props.order.templateId && props.order.templateId === 54)
        || (props.order.templateId && props.order.templateId === 134)//world cup
        || (props.order.templateId && props.order.templateId === 136)//jersey kit
        ? <Button color='purple' onClick={props.sendToFindShirt}>FIND SHIRT</Button>
        : ""

    return (
        <div>
            {sendButton}
        </div>
    )
}

export function SendToConfirmOrder(props) {
    const sendButton = props.order.itemType === 'football'
        || props.order.itemType === 'cranes'
        || (props.order.itemCode && props.order.itemCode.includes('eplJumpers'))
        || (props.order.itemCode && props.order.itemCode.includes('orldCup'))
        ? <Button color='yellow' onClick={props.sendToConfirmOrder}> CONFIRM ORDER</Button>
        : ""

    return (
        <div>
            {sendButton}
        </div>
    )
}

export function MarkOrderAsDeliveredComponent(props) {
    const sendButton = props.order.status === Status.packing
        ? <Button color='yellow' onClick={props.markAsDelivered}> DELIVERED</Button>
        : ""

    return (
        <div>
            {sendButton}
        </div>
    )
}

export function OrderCardsTable(props) {

    const OrderCardList = props.orders.map((order) =>


        <Grid.Column>
            <OrderCard
                key={order.key}
                user={props.user}
                order={order} />
        </Grid.Column>
    )

    return (
        <div>
            <h4>NUM ORDERS:{props.orders.length}</h4>
            <Grid stackable columns={3}>
                {OrderCardList}
            </Grid>
        </div>
    )
}

export function ShowConnectedOrdersLink(props) {

    return (
        <Link to={'/dashboard/connectedOrders/:' + props.phoneNumber}>+ ORDERS</Link>
    )
}




// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/DashboardParts.js